import { gql } from '@apollo/client';

const SaveXselSchoolMapping = gql`
  mutation SaveXselSchoolMapping ($externalXselId: String!, $external7mId: String!) {
    saveXselSchoolMapping(externalXselId: $externalXselId, external7mId: $external7mId)
  }
`;

export default SaveXselSchoolMapping;
